import styled from "@emotion/styled";
import { Button } from "@mui/material";
import { BORDER_STYLE, doNotForwardIsMobileOrRightBarExpanded } from "./AdditionalActionsStyle";
import { ZIndexLevels } from "../geoUtils";


/**
 * Styled component for the Legend container.
 * This container adjusts its layout and positioning based on whether it's viewed on a mobile device.
 *
 * @param isMobile -  Determines if the element is on a mobile device.
 * @param isRightBarExpanded -  Determines if the right bar is open or not
 */
export const LegendContainer = styled( "div", { shouldForwardProp: doNotForwardIsMobileOrRightBarExpanded } )<{ isMobile: boolean, isRightBarExpanded: boolean, isShowingAlerts: boolean }>( ( { isMobile, isRightBarExpanded, isShowingAlerts } ) => ( {
    position: "absolute",
    display: "flex",
    flexDirection: "row",
    border: BORDER_STYLE,
    borderRadius: "10px",
    backgroundColor: "rgba(255,255,255,0.0)",
    bottom: isMobile ? "0px" : "115px",
    right: isMobile ? "0px" : isRightBarExpanded ? "340px" : "16px",
    overflow: "hidden",
    zIndex: ZIndexLevels.BeneathDrawerUiElement,
    width: isMobile ? "100%" : "auto",

    opacity: isShowingAlerts ? 0 : 1,
    transform: isShowingAlerts ? "translateY(10px)" : "translateY(0px)",
    pointerEvents: isShowingAlerts ? "none" : "auto",

    transition: "opacity 0.3s ease, transform 0.3s ease, right 0.3s ease",
} ) );

/**
 * Returns either black or white based on which one will contrast best with
 * the hexColor parameter.
 *
 * @param hexColor - The background color of the button.
 */
export function getContrastColor( hexColor:string )
{
    // Convert hex color to RGB
    const r = parseInt( hexColor.substr( 1, 2 ), 16 );
    const g = parseInt( hexColor.substr( 3, 2 ), 16 );
    const b = parseInt( hexColor.substr( 5, 2 ), 16 );

    // Calculate luminance
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

    // Choose contrasting color
    return luminance > 128 ? "#000000" : "#ffffff";
}
/**
 * Styled component for the Legend buttons.
 * The button's background color is dynamically set based on the risk level.
 *
 * @param riskColor - The background color of the button based on the risk level.
 */
export const StyledLegendButton = styled( Button )<{ hexbackgroundcolor: string }>( ( { hexbackgroundcolor } ) => ( {
    backgroundColor: hexbackgroundcolor,
    borderRadius: "0px",
    flexDirection: "column",
    padding: "5px",
    color: getContrastColor( hexbackgroundcolor ),
    fontSize: "24px",
    flex: "1",
    minWidth: "38px",
} ) );
